import axios from 'axios';

const state = {
    socialstyrelsenGenericAgesAtDiagnosis: [],
    socialstyrelsenGenericAgesAtCauseOfDeathDiagnosis: [],
    socialstyrelsenGenericDiagnosisYears: [],
    socialstyrelsenGenericSexes: [],
    socialstyrelsenGenericRegions: [],
    socialstyrelsenGenericIcdMap: new Map(),
    socialstyrelsenGenericAtcMap: new Map()
}

const getters = {
    stateSocialstyrelsenGenericAgesAtDiagnosis: s => s.socialstyrelsenGenericAgesAtDiagnosis,
    stateSocialstyrelsenGenericAgesAtCauseOfDeathDiagnosis: s => s.socialstyrelsenGenericAgesAtCauseOfDeathDiagnosis,
    stateSocialstyrelsenGenericDiagnosisYears: s => s.socialstyrelsenGenericDiagnosisYears,
    stateSocialstyrelsenGenericSexes: s => s.socialstyrelsenGenericSexes,
    stateSocialstyrelsenGenericRegions: s => s.socialstyrelsenGenericRegions,
    stateSocialstyrelsenGenericIcdMap: s => s.socialstyrelsenGenericIcdMap,
    stateSocialstyrelsenGenericAtcMap: s => s.socialstyrelsenGenericAtcMap
}

async function loadValues(commit, rootState, path, setter) {
    if (!hasAccessRight(rootState.users.user, 'socialstyrelsen-generic')) {
        return;
    }

    let {data} = await axios.get(path, {
        headers: { Authorization: `Bearer ${rootState.users.user.keycloak_token}` },
        params: {}
    })

    await commit(setter, data);
}

function hasAccessRight(user, accessRight) {
  return user
      && user.access_rights
      && user.access_rights.includes(accessRight);
}

const actions = {
    async initSocialstyrelsenGeneric({ commit, rootState }) {
        await loadValues(commit, rootState, 'socialstyrelsen-generic/ages-at-diagnosis', 'setSocialstyrelsenGenericAgesAtDiagnosis')
        await loadValues(commit, rootState, 'socialstyrelsen-generic/ages-at-cause-of-death-diagnosis', 'setSocialstyrelsenGenericAgesAtCauseOfDeathDiagnosis')
        await loadValues(commit, rootState, 'socialstyrelsen-generic/diagnosis-years', 'setSocialstyrelsenGenericDiagnosisYears')
        await loadValues(commit, rootState, 'socialstyrelsen-generic/sexes', 'setSocialstyrelsenGenericSexes')
        await loadValues(commit, rootState, 'socialstyrelsen-generic/regions', 'setSocialstyrelsenGenericRegions')
        await loadValues(commit, rootState, 'socialstyrelsen-generic/icd-map', 'setSocialstyrelsenGenericIcdMap')
        await loadValues(commit, rootState, 'socialstyrelsen-generic/atc-map', 'setSocialstyrelsenGenericAtcMap')
    }
}

const mutations = {
    setSocialstyrelsenGenericAgesAtDiagnosis(s, socialstyrelsenGenericAgesAtDiagnosis) {
        s.socialstyrelsenGenericAgesAtDiagnosis = socialstyrelsenGenericAgesAtDiagnosis;
    },
    setSocialstyrelsenGenericAgesAtCauseOfDeathDiagnosis(s, socialstyrelsenGenericAgesAtCauseOfDeathDiagnosis) {
        s.socialstyrelsenGenericAgesAtCauseOfDeathDiagnosis = socialstyrelsenGenericAgesAtCauseOfDeathDiagnosis;
    },
    setSocialstyrelsenGenericDiagnosisYears(s, cocialstyrelsenGenericDiagnosisYears) {
        s.socialstyrelsenGenericDiagnosisYears = cocialstyrelsenGenericDiagnosisYears;
    },
    setSocialstyrelsenGenericSexes(s, socialstyrelsenGenericSexes) {
        s.socialstyrelsenGenericSexes = socialstyrelsenGenericSexes;
    },
    setSocialstyrelsenGenericRegions(s, socialstyrelsenGenericRegions) {
        s.socialstyrelsenGenericRegions = socialstyrelsenGenericRegions;
    },
    setSocialstyrelsenGenericIcdMap(s, socialstyrelsenGenericIcdMap) {
        s.socialstyrelsenGenericIcdMap = createMap(socialstyrelsenGenericIcdMap);
    },
    setSocialstyrelsenGenericAtcMap(s, socialstyrelsenGenericAtcMap) {
        s.socialstyrelsenGenericAtcMap = createMap(socialstyrelsenGenericAtcMap);
    }
}

function createMap(data) {
  let map = new Map();
  for (let key in data) {
    map.set(key, data[key]);
  }
  return map
}

export default {
    state,
    getters,
    actions,
    mutations
}
